export enum InventoryType {
    Immediate = "Immediate",
    Future = "Future",
    Prebook = "Pre-book",
}
